const reduxStore = {
  App: require("./app/appRedux").reducer,
  SagaAuth: require("./sagaAuth/sagaAuthRedux").reducer,
  Volatile: require("./volatile/volatileRedux").reducer,
  Language: require("./languageSwitcher/languageSwitcherRedux").reducer,
  SagaHome: require("./sagaHome/sagaHomeRedux").reducer,
  SagaBlog: require("./sagaBlog/sagaBlogRedux").reducer,
  SagaBooking: require("./sagaBooking/sagaBookingRedux").reducer,
  SagaContact: require("./sagaContact/sagaContactRedux").reducer,
  SagaMap: require("./sagaMap/sagaMapRedux").reducer,
  SagaCart: require("./sagaCart/sagaCartRedux").reducer,
  SagaPayment: require("./sagaPayment/sagaPaymentRedux").reducer
}

export default reduxStore



// WEBPACK FOOTER //
// ./src/redux/reducers.ts